import { ClassManager } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { IconFA6 } from "./tools/fontAwesome6IconList.tools";

/**
 * Size of icon
 * @see https://fontawesome.com/docs/web/style/size
 */
export enum IconFaSize {
    // Relative sizing
    XS2 = "fa-2xs",
    XS = "fa-xs",
    SM = "fa-sm",
    LG = "fa-lg",
    XL = "fa-xl",
    XL2 = "fa-2xl",
    // Literal sizing
    X1 = "fa-1x",
    X2 = "fa-2x",
    X3 = "fa-3x",
    X4 = "fa-4x",
    X5 = "fa-5x",
    X6 = "fa-6x",
    X7 = "fa-7x",
    X8 = "fa-8x",
    X9 = "fa-9x",
    X10 = "fa-10x"
}

/** 
 * Rotation of icon
 * @see https://fontawesome.com/v5.15/how-to-use/on-the-web/styling/rotating-icons
 */
export enum IconFaRotate {
    ROTATE_90 = "fa-rotate-90",
    ROTATE_180 = "fa-rotate-180",
    ROTATE_270 = "fa-rotate-270",
    FLIP_HORIZONTAL = "fa-flip-horizontal",
    FLIP_VERTICAL = "fa-flip-vertical",
    FLIP_BOTH = "fa-flip-both"
}

/** 
 * Animation of icon
 * @see https://fontawesome.com/v5.15/how-to-use/on-the-web/styling/rotating-icons
 */
export enum IconFaAnimation {
    SPIN = "fa-spin",
    ROTATE = "fa-pulse"
}

/** Fontawesome class for icons, apply fixed with on icon */
export const FA_FW = "fa-fw";

/** Refresh icon size, based on options.size */
export function refreshIconFaSize(classManager: ClassManager, size?: IconFaSize): void {
    if (size) {
        // Add to dynamic classlist 
        classManager.add(...size.split(" "));
    }
}

/** Refresh icon fixedWidth, based on options.size */
export function refreshIconFaFixedWidth(classManager: ClassManager, fixedWidth?: boolean): void {
    if (fixedWidth) {
        // Add to dynamic classlist 
        classManager.add("fa-fw");
    }
}

/** Refresh icon inverse style, based on options.inverse */
export function refreshIconFaInverse(classManager: ClassManager, inverse?: boolean): void {
    if (inverse) {
        // Add to dynamic classlist 
        classManager.add("fa-inverse");
    }
}


/** Refresh icon animation, based on options.animation */
export function refreshIconFaAnimation(classManager: ClassManager, animation?: IconFaAnimation): void {
    if (animation) {
        classManager.add(animation);
    }
}


/** Refresh icon rotation, based on options.rotate */
export function refreshIconFaRotate(classManager: ClassManager, rotate?: IconFaRotate): void {
    if (rotate) {
        classManager.add(rotate);
    }
}


/** Refresh display of icon */
export function refreshIconFaDisplay(classManager: ClassManager, cssClasses?: string[]): void {

    // Clean added css classes
    classManager.clear();

    // Add custom classes
    classManager.add(...cssClasses ?? []);
}

/**
 * @returns full icon name for given icon name
 * ex:
 * getIconFaName(IconFA6.AIR_CONDITIONER) => fa-air-conditioner
 */
export function getIconFaName(iconName: IconFA6): string {
    return "fa-" + iconName;
}